function findSubjectAttrToSimulator(nodes) {

    const attributeMap = {};

    nodes
        .filter(node => (
            node.type === 'subject'
            || node.type === 'condition'
            || node.type === 'application'
            || node.type === 'restfulapi'
            || node.type === 'router'
            || node.type === 'path'
            || node.type === 'data'
        ))
        .flatMap(extractUsedAttributesFromNode)
        .forEach(attr => {
            // const key = `${attr.name}::${attr.attributeType}`;
            const key = `${attr.name}`;
            if (!attributeMap[key]) {
                attributeMap[key] = {
                    name: attr.name,
                    attributeType: attr.attributeType,
                    count: 0
                };
            }
            attributeMap[key].count += 1;
        });

    const usedSubjectAttributeSet = attributeMap;

    return usedSubjectAttributeSet;
}

function extractUsedAttributesFromNode(node) {
    //check subject constraint
    if (
        (
            node.type === 'subject'
            || node.type === 'application'
            || node.type === 'restfulapi'
            || node.type === 'router'
            || node.type === 'path'
            || node.type === 'data'
        ) &&
        node.data?.general_properties?.subjectConstraints
    ) {
        return node.data.general_properties.subjectConstraints.flatMap(constraint =>
            (constraint.child || []).map(child => ({
                name: child?.l_operand?.name,
                attributeType: child?.l_operand?.attributeType
            }))
        ).filter(attr => attr.name && attr.attributeType)
    }

    // check condition
    if (
        node.type === 'condition' &&
        node.data?.general_properties?.conditions
    ) {
        return node.data.general_properties.conditions.flatMap(condition =>
            (condition.subConditions || [])
                .map(sub => {
                    if (sub?.value_property?.value_type === 'Subject') {
                        return {
                            name: sub?.value_property?.value,
                            attributeType: "Unknown" // เนื่องจากไม่ได้เก็บค่า attributeType ในเงื่อนไข เราจึงไม่สามารถระบุได้
                        };
                    }
                    return null;
                })
                .filter(attr => (attr && attr.name && attr.attributeType))
        );
    }

    // case อื่นๆ
    return []
}

export default findSubjectAttrToSimulator